<div class="page-container fia-container container">
  <div class="row w-100 controls">
    <form class="col-4" [formGroup]="form">
      <mat-form-field class="col-12 default-select">
        <mat-select
          formControlName="defaultsControl"
          [placeholder]="'Preset Table Filtering and Sorting'"
          (selectionChange)="useDefault($event)"
        >
          @for (opt of defaults; track opt.label) {
            <mat-option [value]="opt.label">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <div class="grid-actions">
      <button
        type="button"
        mat-button
        color="primary"
        class="grid-button"
        (click)="exportToExcel(viaGrid)"
      >
        <mat-icon>cloud_download</mat-icon>Download Excel File
      </button>
      <app-grid-column-filter
        [columns]="gridColumns"
        (columnsUpdated)="externalColumnsUpdated($event)"
      />
      <button
        type="button"
        mat-button
        color="primary"
        class="reset-button pull-right"
        (click)="useDefault({ value: 'clear' }, true)"
      >
        <mat-icon>replay</mat-icon>Reset
      </button>
    </div>
  </div>
  <kendo-grid
    #viaGrid="kendoGrid"
    class="col-12"
    [kendoGridBinding]="ogData"
    [skip]="state.skip"
    [pageSize]="state.take"
    [pageable]="true"
    [resizable]="true"
    [sortable]="{ allowUnsort: true, mode: 'multiple' }"
    [sort]="state.sort"
    [filterable]="'menu'"
    [columnMenu]="{ columnChooser: false }"
    [filter]="filter"
    [groupable]="true"
    [group]="state.group"
    [height]="gridHeight()"
    [navigable]="true"
    (filterChange)="filterChange($event)"
    (dataStateChange)="dataStateChange($event)"
  >
    @for (column of gridColumns; track column) {
      <kendo-grid-column
        [field]="column.DataField"
        [hidden]="isHidden(column.DataField)"
        [title]="column.Label"
        [sortable]="column.Sort"
        [filterable]="column.Filter"
        [groupable]="column.Group"
        [media]="column.RespVis"
        [filter]="column.DataType"
        [width]="column.Width ? column.Width : 150"
        [sticky]="column.Sticky"
      >
        @if (column.Sort || column.Filter) {
          <ng-template let-service="service" kendoGridColumnMenuTemplate>
            @if (column.Sort) {
              <kendo-grid-columnmenu-sort [column]="column" [service]="service">
                <kendo-grid-messages
                  [sortAscending]="getFilterMenuText(column.Type, 'asc')"
                  [sortDescending]="getFilterMenuText(column.Type, 'desc')"
                />
              </kendo-grid-columnmenu-sort>
            }
            @if (column.Filter) {
              <kendo-grid-columnmenu-filter
                [column]="column"
                [service]="service"
              >
                <ng-template
                  let-filter="filter"
                  let-filterService="filterService"
                  kendoGridFilterMenuTemplate
                >
                  <kendo-multiselect
                    style="width: 99%"
                    textField="display"
                    valueField="value"
                    placeholder="Filter By..."
                    [data]="filterData[column.DataField]"
                    [valuePrimitive]="true"
                    [value]="filter | filterValues"
                    [filterable]="true"
                    [fillMode]="'outline'"
                    (valueChange)="
                      filterValueChange($event, column.DataField, filterService)
                    "
                    (filterChange)="onFilterChange($event, column.DataField)"
                  />
                </ng-template>
              </kendo-grid-columnmenu-filter>
            }
          </ng-template>
        }
        @switch (column.Type) {
          @case ('integer') {
            <ng-template let-dataItem kendoGridCellTemplate>
              {{ dataItem[column.DataField] | number: '1.0-0' }}
            </ng-template>
            <ng-template
              let-group
              let-field="field"
              let-value="value"
              kendoGridGroupHeaderTemplate
              >{{ value | number: '1.0-0' }}</ng-template
            >
          }
          @case ('perc') {
            <ng-template let-dataItem kendoGridCellTemplate>
              {{
                dataItem[column.DataField] === 'N/A' ||
                dataItem[column.DataField] === 'Uncapped'
                  ? dataItem[column.DataField]
                  : (dataItem[column.DataField] | percent)
              }}
            </ng-template>
            <ng-template
              let-group
              let-field="field"
              let-value="value"
              kendoGridGroupHeaderTemplate
            >
              {{ value | percent }}
            </ng-template>
          }
          @case ('perc2') {
            <ng-template let-dataItem kendoGridCellTemplate>
              @if (
                dataItem[column.DataField] === -9.99 ||
                dataItem[column.DataField] === -999
              ) {
                N/A
              } @else {
                @if (
                  dataItem[column.DataField] === 'N/A' ||
                  dataItem[column.DataField] === 'Uncapped'
                ) {
                  {{ dataItem[column.DataField] }}
                } @else {
                  {{ dataItem[column.DataField] | percent: '1.2' }}
                }
              }
            </ng-template>
            <ng-template
              let-group
              let-field="field"
              let-value="value"
              kendoGridGroupHeaderTemplate
            >
              {{ value | percent: '1.2' }}
            </ng-template>
          }
          @case ('curr') {
            <ng-template let-dataItem kendoGridCellTemplate>
              {{ dataItem[column.DataField] | currency }}
            </ng-template>
            <ng-template
              let-group
              let-field="field"
              let-value="value"
              kendoGridGroupHeaderTemplate
            >
              {{ value | currency }}
            </ng-template>
          }
        }

        @if (column.DataField === 'VARate$RateLockPeriod') {
          <ng-template let-dataItem kendoGridCellTemplate>
            @switch (dataItem[column.DataField]) {
              @case ('F') {
                Full Term
              }
              @case ('A') {
                Annual
              }
              @case ('S') {
                Semi-annual
              }
              @case ('Q') {
                Quarterly
              }
              @case ('M') {
                Monthly
              }
              @case ('D') {
                Daily
              }
            }
          </ng-template>
        }
      </kendo-grid-column>
    }
    <kendo-grid-excel
      fileName="RightBridge-RILA.xlsx"
      [fetchData]="excelData"
    />
    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <kendo-pager-prev-buttons />
      <kendo-pager-numeric-buttons [buttonCount]="buttonCount" />
      <kendo-pager-next-buttons />
      <kendo-pager-input />
      <kendo-pager-info />
      <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
    </ng-template>
  </kendo-grid>
  <ngx-loading [show]="loading" />
</div>
